import React from 'react';
import { FormField } from '../../../../../../../global/form/form-field/form-field';

export type ModuleDropdownProps<TValue extends string> = {
    label: React.ReactNode;
    value: TValue;
    options: { value: TValue; label: string }[];
    onChange: (value: TValue) => void;
    disabled?: boolean;
    className?: string;
};

export const ModuleDropdown = <TValue extends string>({
    label, value, options, onChange, disabled, className,
}: ModuleDropdownProps<TValue>) => (
    <FormField label={label} className={className}>
        <select
            value={value}
            onChange={e => onChange(e.target.value as TValue)}
            className='oe-form-field__control'
            disabled={disabled}
        >
            {options.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
        </select>
    </FormField>
);
